import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { SharedModule } from "../shared/shared.module";
import { ServitlyBadgeComponent } from "./badge/servitly-badge.component";
import { FilledButtonComponent } from "./button/filled-button.component";
import { OutlinedButtonComponent } from "./button/outlined-button.component";
import { ServitlyButtonComponent } from "./button/servitly-button.component";
import { StandardButtonComponent } from "./button/standard-button.component";
import { ServitlyIconButtonComponent } from "./icon-button/servitly-icon-button.component";
import { ServitlyToggleButtonComponent } from "./toggle-button/servitly-toggle-button.component";

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatTooltipModule,
        MatIconModule,
        SharedModule
    ],
    declarations: [
        ServitlyButtonComponent,
        FilledButtonComponent,
        OutlinedButtonComponent,
        StandardButtonComponent,
        ServitlyIconButtonComponent,
        ServitlyToggleButtonComponent,
        ServitlyBadgeComponent
    ],
    exports: [
        ServitlyButtonComponent,
        ServitlyIconButtonComponent,
        ServitlyToggleButtonComponent,
        ServitlyBadgeComponent
    ]
})
export class StyleModule { }